let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hg8mR")).then(() => parcelRequire('61Hor'));